import Extintores from '../assets/categorias/extintores.png';
import Armarios from '../assets/categorias/Armarios.png';
import CarretelFixo from '../assets/Produtos/carreteis/CarretelFixo.png';
import CarretelBalanco from '../assets/Produtos/carreteis/CarretelBalanco.png';
import CarretelAco from '../assets/Produtos/carreteis/CarretelAco.png';
import Vitalic from '../assets/categorias/Vitalic.png';
import Suporte from '../assets/categorias/Suporte.png';

export const categories = [
    { // Extintores
        id: 1,
        name: 'Extintores',
        description: 'A Firesafety oferece uma linha completa de extintores de incêndio de alta qualidade com certificação SABS 1910, SABS 1322 e SABS 1567 para atender a todas as necessidades marítimas, industriais, automotivas e residenciais.',
        image: Extintores,
        color: 'from-red-500 to-red-600',
        products: 15
    },
    { //Enroladores de mangueiras
        id: 2,
        name: 'Enroladores de mangueira',
        description: 'Enroladores de mangueiras de incêndio para' +
            ' edifícios comerciais, industriais e públicos, o que' +
            ' permite uma resposta rápida a um pequeno incêndio em desenvolvimento.',
        image:CarretelFixo,
        color: 'from-orange-500 to-orange-600',
        products: 8
    },
    {// sprinklers
        id: 3,
        name: 'sprinklers',
        description: 'Produtos e sistemas de proteção contra incêndio',
        image:Vitalic,
        color: 'from-blue-500 to-blue-600',

    },
    { // Suportes de Veículos
        id: 4,
        name: 'Suportes de Veículos',
        description: 'Os suportes de veículos são feitos para caber em ' +
            'vários tamanhos e normalmente são fabricados com uma alça simples ou dupla. ' +
            'Alças adicionais podem ser adicionadas às necessidades específicas da suíte.',
       image: Suporte,
        color: 'from-purple-500 to-purple-600',
        products: 6
    },
    { // Armários de incêndio
        id: 5,
        name:'armários de incêndio',
        description:'Os armários de incêndio feitos sob medida da SafeQuip são fabricados' +
            ' por artesãos altamente qualificados, usando apenas resina e materiais de' +
            ' poliéster aprovados pela SABS.',
        image:Armarios,
        color: 'from-green-500 to-green-600',
        products: 5
    },
    {//Sinais Simbolicos
        id: 6,
        name:'Sinalização',
        description:'A FireSafety fornece equipamentos de segurança contra incêndio de alta'  +
         ' qualidade e também uma variedade de sinais de alerta e sinais de segurança contra incêndio,' +
         'incluindo placas chevron disponíveis em ABS ou fosforescente.',
        image:'https://safequip.co.za/wp-content/uploads/2020/07/Location-of-Fire-Extinguisher.jpg',
        color: 'from-green-500 to-green-600',
    },
    {//Variado
        id: 7,
        name:'Variado',
        description:'A gama de itens diversos da SafeQuip associados à prevenção e combate a incêndios inclui itens como o alarme de sinalização Safe&Loud, cobertores de incêndio populares, machados, kits de primeiros socorros, alarmes de fumaça e muito mais.',
        image:'https://safequip.co.za/wp-content/uploads/2020/04/Fire-Blanket-.jpg',
        color: 'from-green-500 to-green-600',
    
    },
    {//Mangueiras e Acoplamentos Layflat
        id: 8,
        name:'Mangueiras e Acoplamentos Layflat',
        description:'A FireSafety fornece uma ampla gama de mangueiras de incêndio de alta pressão que transferem água ou outro retardante de fogo, como espuma.',
        image:'https://safequip.co.za/wp-content/uploads/2020/07/Duraflex-Firehose.jpg',
        color: 'from-green-500 to-green-600',
       
    },
    {//Agentes Extintores
        id: 9,
        name:'Agentes Extintores',
        description:'Os agentes extintores podem ser encontrados nas formas sólida, líquida ou gasosa. Quando combinados com sistemas de supressão de incêndio ou sistemas de sprinklers contra incêndio, eles são altamente eficazes na extinção de incêndios.',
        image:'https://safequip.co.za/wp-content/uploads/2020/04/refinaryFire6Safequip.jpg',
        color: 'from-green-500 to-green-600',
     
    },
   /* {//Equipamento de mergulho
        id: 10,
        name:'Equipamento de Merglho',
        description:'O FireSafety segue os mais rígidos padrões de qualidade. A SafeQuip é um fabricante líder aprovado pela SABS e distribuidor atacadista de equipamentos de combate a incêndios no continente africano.',
        image:'https://previews.123rf.com/images/lembergvector/lembergvector1608/lembergvector160800100/61664940-scuba-diving-equipment-accessories-collection-diver-man-in-underwater-wetsuit-underwater-hunting.jpg',
        color: 'from-green-500 to-green-600',
    
    },*/
    {//Hidrantes de Incêndio & Tubos de Suporte
        id: 11,
        name:'Hidrantes de Incêndio & Tubos de Suporte',
        description:'As válvulas de hidrante da FireSafety são feitas com os melhores materiais da indústria. Com a mangueira conectada ao hidrante, a válvula pode ser aberta para fornecer um poderoso fluxo de água para extinguir um incêndio.',
        image:'https://safequip.co.za/wp-content/uploads/2020/04/Fire-Hydrant-Valve-.jpg',
        color: 'from-green-500 to-green-600',
      
    },
  /*  {//Equipamentos e bombas agrícolas e florestais
        id: 12,
        name:'Equipamentos e bombas agrícolas e florestais',
        description:'A FireSafety possui uma ampla seleção de equipamentos de combate a incêndios na savana, sendo o produto mais popular a unidade móvel de combate a incêndios Fire King.',
        image:'https://safequip.co.za/wp-content/uploads/2020/04/Davey-Single-Impeller-Skid-Unit-.jpg',
        color: 'from-green-500 to-green-600',
        
    } */
];

export const products = {
    1: [ // Extintores
        {
            id: 1,
            name: 'Extintor de incêndio DCP de 0,6 kg (Firemate)',
            image: 'https://safequip.co.za/wp-content/uploads/2021/05/0.6kg-DCP-Firemate.jpg',
            description: 'O extintor de incêndio DCP 0,6kg (Firemate)'+
             'é o menor extintor desta faixa e adequado para incêndios'+
             'de classe A, B ou C, ou uma combinação desses tipos. Esses'+ 
             'extintores são classificados como descartáveis e estão em conformidade com a SANS 1322.',
            specifications: {
                Altura_do_cilindro:	'285 milímetros',
                Diâmetro:	'68 milímetros',
                Massa_vazia: '0,6 kg',
                Massa_cheia: '1,2 kg',
                Descarga: '6 seg',
                Pressão_de_trabalho:	'1400kPa',
                Pressão_de_teste:	'2100kPa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'nenhum'
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 2,
            name: 'Extintor de incêndio DCP de 1,0 kg (Firemate)',
            image:'https://safequip.co.za/wp-content/uploads/2020/04/1.0kg-DCP-Firemate.jpg',
            description: 'O extintor de incêndio DCP 1.0kg (Firemate) é adequado para incêndios de classe A, B ou C, ou uma combinação desses tipos. Todos os extintores fornecidos estão em conformidade com as classificações mínimas de incêndio, conforme especificado na SANS 1910.',
            specifications: {
               Altura_do_cilindro:	'330 milímetros',
                Diâmetro:	'80 milímetros',
                Massa_vazia: '0,8 kg',
                Massa_cheia: '1,8 kg',
                Descarga: '6 seg',
                Pressão_de_trabalho:	'1400kPa',
                Pressão_de_teste:	'2100kPa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 3,
            name: 'Extintor de incêndio DCP de 1,5 kg (Firemate)',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/1.5kg-DCP-Firemate.jpg',
            description: 'O Extintor DCP 1,5kg (Firemate) é o extintor ideal para a indústria automobilística, adequado para incêndios de Classe A, B ou C, ou uma combinação desses tipos. Todos os extintores fornecidos estão em conformidade com as classificações mínimas de incêndio, conforme especificado na SANS 1910:2009.',
            specifications: {
                 Altura_do_cilindro:	'330 milímetros',
                Diâmetro:	'80 milímetros',
                Massa_vazia: '1,3 kg',
                Massa_cheia: '2,8 kg',
                Descarga: '6 seg',
                Pressão_de_trabalho:	'1400kPa',
                Pressão_de_teste:	'2100kPa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 4,
            name: 'Extintor de incêndio DCP de 2,5 kg (Firemate)',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/2.5kg-DCP-Firemate.jpg',
            description: 'O extintor de incêndio DCP 2,5 kg (Firemate) é altamente eficaz para riscos elétricos, pois interfere no processo de combustão e fornece um rápido knockdown de fogo. Adequado para incêndios de Classe A, B ou C, ou uma combinação desses tipos. Todos os extintores fornecidos estão em conformidade com as classificações mínimas de incêndio, conforme especificado na SANS 1910:2009.',
            specifications: {
                 Altura_do_cilindro:	'415 milímetros',
                Diâmetro:	'110 milímetros',
                Massa_vazia: '1,4 kg',
                Massa_cheia: '3,9 kg',
                Descarga: '6 seg',
                Pressão_de_trabalho:	'1400kPa',
                Pressão_de_teste:	'2100kPa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
         {
            id: 5,
            name: 'Unidade de carrinho DCP de 25 kg',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/25kg-DCP-Trolley-Unit-Safequip.jpg',
            description: 'Uma unidade de carrinho precisa ser forte e confiável. Os carrinhos de extintores de incêndio da Safequip são construídos com aço e tinta de revestimento em pó epóxi para evitar a corrosão. Os carrinhos são fornecidos com suportes para fixar com segurança os extintores de incêndio. Projetadas para proteger grandes riscos industriais e marítimos, as unidades móveis com rodas podem ser fornecidas em uma variedade de tamanhos e com um agente extintor para atender ao risco específico.',
            specifications: {
                 Altura_do_cilindro:	'795 milímetros',
                Diâmetro:	'250 milímetros',
                Massa_vazia: '14 kg',
                Massa_cheia: '39 kg',
                Descarga: '15 seg',
                Pressão_de_trabalho:	'1400kPa',
                Pressão_de_teste:	'2100kPa',
                Pressão_de_ruptura:	'5500kPa',
                Alcance_Efectivo:	'7 milhões'
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
         {
            id: 6,
            name: 'Extintores de incêndio DCP de 4,5 kg (guindaste azul)',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/4.5kg-DCP-Bluecrane.jpg',
            description: 'Extintores de 4,5 kg ou mais são equipados com uma mangueira de descarga de alta pressão e um bico de descarga que se localiza em um suporte de bico em forma de L fixado ao anel de pé do extintor.',
            specifications: {
                 Altura_do_cilindro:	'435 milímetros',
                Diâmetro:	'179 milímetros',
                Massa_vazia: '3,3 kg',
                Massa_cheia: '7,8 kg',
                Descarga: '9 seg',
                Pressão_de_trabalho:	'1400kPa',
                Pressão_de_teste:	'2100kPa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 7,
            name: 'Extintores de incêndio DCP de 50 kg ',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/50kg-DCP-Trolley-Unit-Safequip.jpg',
            description: 'Este carrinho DCP pode alcançar até 9 m ao combater um incêndio em locais com acesso limitado. Um carrinho de extintores de incêndio precisa ser robusto e confiável. Os carrinhos de extintores de incêndio da Safequip são construídos em aço e revestidos com tinta epóxi em pó para evitar corrosão. Os carrinhos são fornecidos com suportes para fixação segura dos extintores. Projetadas para proteger grandes riscos industriais e marítimos, as unidades móveis com rodas podem ser fornecidas em diversos tamanhos e com um agente extintor adequado ao risco específico.',
            specifications: {
                 Altura_do_cilindro:	'1020 milímetros',
                Diâmetro:	'300 milímetros',
                Massa_vazia: '22 kg',
                Massa_cheia: '72 kg',
                Descarga: '25 seg',
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
         {
            id: 8,
            name: 'Extintores de incêndio DCP 9kg (Blue Crane)',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/9kg-DCP-Bluecrane.jpg',
            description: 'O extintor de 9 kg é o maior da linha Blue Crane e é adequado para incêndios de Classe A, B ou C, ou uma combinação desses tipos. Todos os extintores fornecidos atendem às classificações mínimas de resistência ao fogo especificadas na norma SANS 1910:2009.',
            specifications: {
                Altura_do_cilindro:	'545 milímetros',
                Diâmetro:	'178 milímetros',
                Massa_vazia: '4,2 kg',
                Massa_cheia: '13,2 kg',
                Descarga: '12 seg',
                Pressão_de_trabalho:	'1400kPa',
                Pressão_de_teste:	'2100kPa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
         {
            id: 9,
            name: 'Extintor de incêndio de CO2 de 2 kg (liga de aço)',
            image: 'https://safequip.co.za/wp-content/uploads/2021/05/2kg-Alloy-Steel-Cima2.jpg',
            description: 'Este extintor de aço de liga de CO2 de 2 kg foi projetado especificamente para incêndios envolvendo líquidos inflamáveis ​​e riscos elétricos, incêndios de Classe C e Classe B. Nossos extintores de incêndio de dióxido de carbono de alta qualidade, certificados pela SANS 1567, são revestidos em aço ou alumínio e projetados especialmente para serem fáceis de usar.',
            specifications: {
                Altura_do_cilindro:	'585 milímetros',
                Diâmetro:	'103 milímetros',
                Massa_vazia: '4,3 kg',
                Massa_cheia: '6,5 kg',
                Descarga: '8 seg',
                Pressão_de_trabalho:	'174Bar',
                Pressão_de_teste:	'250Bar',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
         {
            id: 10,
            name: 'Extintor de incêndio de CO2 de 5 kg (liga de aço)',
            image: 'https://safequip.co.za/wp-content/uploads/2021/05/5kg-CO2-Alloy-Steel.jpg',
            description: 'Este extintor de aço de liga de CO2 de 5 kg foi projetado especificamente para incêndios envolvendo líquidos inflamáveis ​​e riscos elétricos, incêndios de Classe C e Classe B. Nossos extintores de incêndio de dióxido de carbono de alta qualidade, certificados pela SANS 1567, são revestidos em aço ou alumínio e projetados especialmente para serem fáceis de usar.',
            specifications: {
                Altura_do_cilindro:	'770 milímetros',
                Diâmetro:	'135 milímetros',
                Massa_vazia: '8,4 kg',
                Massa_cheia: '14,4 kg',
                Descarga: '13 seg',
                Pressão_de_trabalho:	'174Bar',
                Pressão_de_teste:	'250Bar',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
         {
            id: 11,
            name: 'Unidade de carrinho de CO2 de 10 kg (liga de aço)',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/10kg-CO2-Trolley-Unit.jpg',
            description: 'Os carrinhos de CO2 são especialmente adequados para transportar extintores de incêndio de CO2 . Oferecem ao usuário alternativas móveis eficazes de combate a incêndios, pois podem ser facilmente movimentados.',
            specifications: {
                Altura_Total:	'1160 milímetros',
                Diâmetro:	'135 milímetros',
                Massa_cheia: '10 kg',
                Descarga: '15 seg',
                Pressão_de_trabalho:	'174Bar',
                Pressão_de_teste:	'250Bar',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 12,
            name: '2 x 10 kg de unidade de carrinho de CO2 ( liga de aço)',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/2x10kg-CO2-Trolley-Unit.jpg',
            description: 'Esta linha de extintores de incêndio móveis prevê riscos de incêndio em que extintores portáteis seriam inadequados e um sistema fixo projetado não seria justificado.',
            specifications: {
                Altura_Total:	'1160 milímetros',
                Diâmetro:	'135 milímetros',
                Massa_cheia: '64 kg',
                Capacidade_do_tanque:'2 x 10 kg',
                Descarga: '15 seg',
                Pressão_de_trabalho: '174Bar',
                Pressão_de_teste:	'250Bar',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'220kpa'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 13,
            name: 'Extintor Lith-ex (à base de água) 1 litros',
            image: 'https://safequip.co.za/wp-content/uploads/2024/05/Untitled-design-17.png',
            description: 'Esta linha de extintores de incêndio móveis prevê riscos de incêndio em que extintores portáteis seriam inadequados e um sistema fixo projetado não seria justificado.',
            specifications: {
                Capacidade_do_tanque:'1 litros'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 14,
            name: 'Extintor de incêndio a bateria de lítio 500ml',
            image: 'https://safequip.co.za/wp-content/uploads/2024/05/Untitled-design-17.png',
            description: 'O Extintor de Incêndio DPC 500ml,  é uma solução compacta e eficiente, projetada especificamente para combater incêndios envolvendo baterias de lítio. Seu tamanho portátil o torna ideal para uso pessoal, escritórios domésticos e segurança em trânsito. Este extintor garante uma supressão rápida e eficaz de incêndios, proporcionando tranquilidade em ambientes onde baterias de lítio são utilizadas.',
            specifications: {
                Capacidade_do_tanque:'500 litio'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 15,
            name: 'Extintor Lith-ex (à base de água) 6 litros, 13A',
            image: 'https://safequip.co.za/wp-content/uploads/2023/11/Untitled-1_0002_LITH-EX-6-liter.jpg',
            description: 'O Extintor de Incêndio DPC é um extintor de incêndio à base de água de alta qualidade, projetado para combater incêndios envolvendo baterias de íons de lítio. Com capacidade de 6 litros e classificação de resistência ao fogo 13A, este extintor oferece desempenho e confiabilidade excepcionais em situações críticas. Ideal para uso em ambientes com baterias de íons de lítio, como data centers, fábricas e armazéns, o Extintor Lith-Ex garante uma extinção rápida e eficaz do incêndio.',
            specifications: {
                Capacidade_do_tanque:'6 litros'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 16,
            name: 'Extintor Lith-ex (à base de água) 9 litros, 13A',
            image: 'https://safequip.co.za/wp-content/uploads/2023/11/Untitled-1_0001_LITH-EX-9-liter.jpg',
            description: 'O Extintor de Incêndio DPC é um extintor de incêndio à base de água de alta qualidade, projetado para combater incêndios envolvendo baterias de íons de lítio. Com capacidade de 9 litros e classificação de resistência ao fogo 13A, este extintor oferece desempenho e confiabilidade excepcionais em situações críticas. Ideal para uso em ambientes com baterias de íons de lítio, como data centers, fábricas e armazéns, o Extintor Lith-Ex garante uma extinção rápida e eficaz do incêndio.',
            specifications: {
                Capacidade_do_tanque:'6 litros'
          
            },
            features: [ 'Extintores de incêndio DCP', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 17,
            name: 'Extintor de incêndio de espuma 9l',
            image: 'https://safequip.co.za/wp-content/uploads/2021/08/9l-Foam-Extinguisher.jpg',
            description: 'Este extintor com conteúdo de espuma sob pressão armazenada é ideal para situações de múltiplos riscos, onde é provável encontrar materiais combustíveis de Classe A e líquidos e gases inflamáveis ​​de Classe B, ou onde os riscos de Classe B representam um perigo direto.',
            specifications: {
                Altura_Total:	'580 milímetros',
                Diâmetro:	'176 milímetros',
                Massa_cheia: '12,9 kg',
                Capacidade_do_tanque:'2 x 10 kg',
                Descarga: '15 seg',
                Pressão_de_trabalho: '1400kpa',
                Pressão_de_teste:	'2100kpa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'2200kpa'
          
            },
            features: [ 'Unidade de espuma móvel ', 'Extintores de incêndio', 'Firemate' ]
        },{
            id: 18,
            name: 'Unidade de espuma móvel HL120',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Untitled-1_0009_foamTrolleySafequip1.jpg',
            description: 'A Unidade Móvel de Espuma HL120, com design inovador, é uma unidade móvel totalmente autônoma, desenvolvida especificamente para a rápida aplicação de um agente extintor de espuma em incêndios e derramamentos químicos. Um refinamento adicional foi alcançado por meio de uma revisão ergonômica detalhada e um design com centro de gravidade mais baixo, resultando em melhor manuseio e mobilidade.',
            specifications: {
                Massa_vazia:'65 kg',
                Capacidade_tanque:	'120 litros',
                Taxa_de_fluxo:	'4 litros/seg',
                Pressão:	'0,7 MPa',
                pressão_de_trabalho:	'0,6-0,8 MPa',
                descarga:	'≥15m',
                Ração_de_mistura:	'1%-6%',
                Ração_de_Expansão:	'≥4',
                Tempo_de_drenagem:	'≥60 seg'
          
            },
            features: [ 'Unidade de espuma móvel ', 'Extintores de incêndio', 'Firemate' ]
        },{
            id: 19,
            name: 'Extintor de incêndio químico úmido de 6 litros',
            image: 'https://safequip.co.za/wp-content/uploads/2021/06/Wet-Chemical-Extinguisher.jpg',
            description: 'O extintor de produtos químicos úmidos da Safequip, especialmente formulado para suprimir incêndios de Classe F, foi projetado para combater incêndios resultantes da queima de gorduras e óleos comestíveis em fritadeiras.',
            specifications: {
                Altura_Total:	'430 milímetros',
                Diâmetro:	'164 milímetros',
                Massa_cheia: '7,6 kg',
                Volume: '7,71l',
                Pressão_de_trabalho: '1400kpa',
                Pressão_de_teste:	'3000kpa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'2200kpa'
          
            },
            features: [ 'Extintor de incêndio químico úmido', 'Extintores de incêndio', 'Firemate' ]
        },
        {
            id: 20,
            name: 'Extintor de incêndio de água 9l',
            image: 'https://safequip.co.za/wp-content/uploads/2021/06/9l-water-extinguisher.jpg',
            description: 'Extintores de incêndio de água são adequados para incêndios de classe A causados ​​pela combustão de materiais sólidos, principalmente de origem orgânica, como: madeira, papel, palha, tecidos, carvão etc.',
            specifications: {
                Altura_Total:	'580 milímetros',
                Diâmetro:	'175 milímetros',
                Massa_cheia: '12,9 kg',
                Descarga: '12 seg',
                Pressão_de_trabalho: '1400kpa',
                Pressão_de_teste:	'2100kpa',
                Pressão_de_ruptura:	'5500kPa',
                Válvula_de_segurança:	'2200kpa'
          
            },
            features: [ 'Extintor de incêndio de água', 'Extintores de incêndio', 'Firemate' ]
        },








    ],
    2: [ // Carreteis de mangueira de incendio
        {
            id: 4,
            name: 'Carretel de mangueira de incêndio (padrão / fixo)',
            price: '',
            image: CarretelFixo,
            description: 'Este carretel de mangueira de incêndio é um carretel de mangueira de incêndio certificado SABS de alta qualidade que é fornecido com um suporte montado na parede, guia de mangueira, bico durável e mangueira de 30m. É aprovado pela SABS de acordo com a SANS 543 com mangueira de incêndio SANS 1086.\n' +
                '\n' +
                'As mangueiras, enroladores de mangueiras' +
                ' e acessórios que a Safequip estoca, são projetados para aplicações industriais.',
            specifications: {
                massa_sem_mangueira: '7,4 kg',
                massa_com_magueira: '18,2 Kg',
                Diâmetro_do_disco:	'575 milímetros',
                Altura:	'660 milímetros',
                Altura_suporte_válvula:	'710 milímetros',
                Proteção_de_parede:	'Armário',
                Projeção_de_parede:	'250 milímetros',
                Mangueira:	'SANS 1086 PVC',
                Dimensão_da_mangueira:	'ID 20mm x 30mm',
                Válvula: '25mm	BSP CP',
                Comprimento_do_jato:	'10m @ 0.2MPa',
                Taxa_de_descarga:	'30 litros/min @300kPa',
                alcance: '40m²',
                decibeis: '85dB',
                vida_util: '10 anos'
            },
            features: [ 'carretéis de mangueira de incêndio', 'segurança contra incêndio', 'segurança ocupacional']
        },
        {
            id: 5,
            name: 'Carretel de mangueira de incêndio (tipo balanço)',
            price: '',
            image: CarretelBalanco,
            description: 'O carretel de mangueira tipo balanço é um carretel de mangueira de incêndio ' +
                'certificado SABS de alta qualidade que é fornecido com um suporte de parede de forma ' +
                'giratória, guia de mangueira, bico durável e mangueira de 30m, facilitando o tambor do ' +
                'carretel de mangueira a ser balançado para longe da parede. É aprovado pela SABS de acordo ' +
                'com a SANS 543 com mangueira de incêndio SANS 1086.',
            specifications: {
                Massa_sem_mangueira:	'7,87 kg',
                Massa_com_mangueira:	'19,4 kg',
                Diâmetro_do_disco:	'575 milímetros',
                Altura_suporte:'660 milímetros',
                Altura_suporte_E_válvula: '710 milímetros',
                Proteção_de_parede:	'Armário',
                Projeção_de_parede:	'290 milímetros',
                Mangueira:	'SANS 1086 PVC',
                Dimensão_da_mangueira:	'ID 20mm x 30mm',
                Válvula: '25mm	BSP CP',
                Comprimento_do_jato:	'10m @ 0.2MPa',
                Taxa_de_descarga:	'30 litros/min @300kPa',
            },
            features: [ 'carretéis de mangueira de incêndio', 'SABS aprovado']
        },
        {
            id: 6,
            name: 'Carretel de mangueira de incêndio (aço inoxidável)',
            price: '',
            image: CarretelAco,
            description: 'A Safequip é uma fabricante e fornecedora líder de enroladores' +
                ' de mangueiras de incêndio para edifícios comerciais, industriais e públicos' +
                ' para resposta a um pequeno incêndio em desenvolvimento. As mangueiras, enroladores' +
                ' de mangueiras e acessórios Safequip stock, são projetados para aplicações industriais.',
            specifications: {
                Massa_sem_mangueira:	'7,55 kg',
                Massa_com_mangueira:	'18,35 kg',
                Diâmetro_do_disco:	'575 milímetros',
                Altura_suporte:	'660 milímetros',
                Altura_suporte_E_válvula:	'710 milímetros',
                Proteção_de_parede:	'Armário',
                Projeção_de_parede:	'250 milímetros',
                Mangueira:	'SANS 1086 PVC',
                Dimensão_da_mangueira:	'ID 20mm x 30mm',
                Válvula: '25mm	BSP CP',
                Comprimento_do_jato:	'10m @ 0.2MPa',
                Taxa_de_descarga:	'30 litros/min @300kPa',
            },
            features: ['carretel de mangueira de incêndio', 'uso industrial', 'segurança ocupacional']
        },
        {
            id: 7,
            name: 'Grampos Twinear',
            price: '',
            image:'https://safequip.co.za/wp-content/uploads/2020/04/Twinear-Clamps.jpg',
            description: 'Grampos de orelha dupla são colocados na extremidade de mangueiras ou extensões de tubo. Quando a orelha é fechada, ela se deforma permanentemente, fazendo com que a faixa fique apertada ao redor da mangueira de incêndio.',
            specifications: {
               Uso:'Enroladores de Mangueiras'
            },
            features: ['carretel de mangueira de incêndio', 'uso industrial', 'segurança ocupacional']
        },
        {
            id: 8,
            name: 'Acessórios para mangueiras de incêndio',
            price: '',
            image:'https://safequip.co.za/wp-content/uploads/2020/04/Fire-Hose-Accessories-Overview.jpg',
            description: 'A Firesafety é líder na fabricação e fornecimento de mangueiras de incêndio em carretéis para edifícios comerciais, industriais e públicos, para atendimento a pequenos incêndios em desenvolvimento. As mangueiras, carretéis e acessórios em estoque da Safequip são projetados para aplicações industriais.',
            specifications: {
                        Válvula_CP: 'Torneira cromada com entrada e saída BSP de 25 mm',
                        Volante_CP: 'Volante com parafuso de trava M4 x 10',
                        Grampos : 'braçadeira de mangueira de aço macio banhada a G12',
                        Porcas_parafusos : 'parafuso sextavado e porca M8 banhados',
                        Porcas_e_parafusos: 'parafuso de cabeça cilíndrica M4 banhado a queijo e porca sextavada',
                        Arruelas: 'M8 Brilhante',
                        Parafusos: 'Parafuso de latão com cabeça de queijo M4',
                        Hidrovia: 'Junta giratória de latão com pescoço de ganso revestido de cádmio',
                        Espaçadores_de_cubo: 'placas curvas espaçadoras de cabine de 180 mm de largura',
                        D_Shackles: 'Manilha de aço carbono niquelado com PVC',
                        Etiqueta: 'Etiqueta de instruções impressas',
                        Bicos: 'Use plástico com mangueira de PVC'
            },
            features: ['carretel de mangueira de incêndio', 'uso industrial', 'segurança ocupacional']
        },{
            id: 9,
            name: 'Capa para carretel de mangueira',
            price: '',
            image:'https://safequip.co.za/wp-content/uploads/2021/06/Hose-Reel-Cover.jpg',
            description: 'fornecedora líder de carretéis para mangueiras de incêndio para edifícios comerciais, industriais e públicos para resposta a pequenos incêndios em desenvolvimento e  oferece uma ampla gama de acessórios para carretéis de mangueiras de incêndio projetados para aplicações industriais, como válvulas, volantes, espaçadores, bicos, porcas e parafusos.',
            specifications: {
               Uso:'Enroladores de Mangueiras'
            },
            features: ['carretel de mangueira de incêndio', 'uso industrial', 'segurança ocupacional']
        },{
            id: 10,
            name: 'Mangueira SANS 1086',
            price: '',
            image:'https://safequip.co.za/wp-content/uploads/2021/06/SANS-1086-Hose.jpg',
            description: 'Mangueira SANS 1086',
            specifications: {
               Uso:'Enroladores de Mangueiras',
               Comprimento: '30m'
            },
            features: ['carretel de mangueira de incêndio', 'uso industrial', 'segurança ocupacional']
        },{
            id: 11,
            name: 'Válvula CP do carretel de mangueira',
            price: '',
            image:'https://safequip.co.za/wp-content/uploads/2021/06/Hose-Reel-CP-Valve.jpg',
            description: 'O carretel de mangueira com válvula CP é um componente essencial para manter a funcionalidade e a confiabilidade do seu sistema de carretel de mangueira. Esta válvula CP, também conhecida como válvula de controle e pressão, desempenha um papel fundamental na regulação do fluxo e da pressão da água, garantindo que o seu carretel de mangueira funcione da melhor forma em situações críticas, como combate a incêndios ou aplicações industriais.',
            specifications: {
               Uso:'Enroladores de Mangueiras'
            },
            features: ['carretel de mangueira de incêndio', 'uso industrial', 'segurança ocupacional']
        },

    ],
    3: [ // Aspersores Victaulic
        {
            id: 7,
            name: 'sprinklers',
            price: '',
            image: Vitalic,
            description: 'A Firesafety fornece produtos inovadores de' +
                ' proteção contra incêndio e soluções de sistema para' +
                ' os desafios enfrentados por engenheiros, empreiteiros, ' +
                'gerentes de propriedade e bombeiros.',
            specifications: {
                filtro: 'PFF2',
                eficiencia: '94%',
                valvula: 'Com válvula',
                certificacao: 'CA-38.987'
            },
            features: ['Filtro de alta eficiência', 'Válvula de exalação', 'Ajuste facial']
        }
    ],
    4: [ // Suporte de Veiculo
        {
            id: 8,
            name: 'Suporte de veículo extra pesado com base redonda',
            price: '',
            image: Suporte,
            description: 'Suportes de veículos para montagem e transporte seguros dos seguintes extintores: 2,5 kg, 4,5 kg e 9 kg.\n' +
                '\n' +
                'Como o nome sugere, os suportes de veículos são montados com segurança em veículos para transportar extintores de incêndio com segurança. Eles estão disponíveis em tamanhos e ' +
                'materiais variados, para permitir uma montagem e remoção rápida e fácil.',
            specifications: {
                Peso_Extintor: '2.5KG, 4.5KG e 9KG',

            },
            features: [ 'Acessórios para extintores de incêndio', 'Suportes para veículos']
        },
        {
            id: 9,
            name: 'Suporte de veículo de alça única para serviço normal DCP Range',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2021/08/Normal-Duty-Single-Strap-DCP.jpg',
            description: 'Para extintores DCP de 4,5 kg e 9 kg.\n' +
                'Alça única.\n' +
                'Suportes de veículos para montagem e transporte seguros dos seguintes extintores: 4,5 kg e 9 kg.\n' +
                '\n' +
                'Como o nome sugere, os suportes de veículos são montados com segurança em' +
                ' veículos para transportar extintores de incêndio com segurança. ' +
                'Eles estão disponíveis em tamanhos e materiais variados, para permitir' +
                ' uma montagem e remoção rápida e fácil.',
            specifications: {
                Peso_Extintor: '4.5KG e 9KG',
                Alça: 'única'
            },
            features: ['Acessórios para extintores de incêndio', 'Suportes para veículos ']
        }, {
            id: 10,
            name: 'Suporte de veículo de alça dupla de serviço normal DCP Range',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2021/08/Normal-Duty-Double-Strap-DCP.jpg',
            description: 'Suportes de veículos para montagem e transporte seguros dos seguintes extintores: 2,5 kg, 4,5 kg e 9 kg.\n' +
                '\n' +
                'Como o nome sugere, os suportes de veículos são montados' +
                ' com segurança em veículos para transportar extintores de ' +
                'incêndio com segurança. Eles estão disponíveis em tamanhos e ' +
                'materiais variados, para permitir uma montagem e remoção rápida e fácil.',
            specifications: {
                Peso_Extintor: '4.5KG e 9KG',
                Alça: 'Dupla'
            },
            features: ['Acessórios para extintores de incêndio', 'Suportes para veículos ']
        },
        {
            id: 11,
            name: 'Suporte de veículo de alça única para serviço pesado DCP Range',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2021/08/Heavy-Duty-Single-Strap-DCP.jpg',
            description: 'Suportes de veículos para montagem e transporte seguros dos seguintes extintores: 1,5 kg e 2,5 kg.\n' +
                '\n' +
                'Como o nome sugere, os suportes de veículos são montados com segurança em veículos para ' +
                'transportar extintores de incêndio com segurança. Eles estão disponíveis em tamanhos e ' +
                'materiais variados, para permitir uma montagem e remoção rápida e fácil.',
            specifications: {
                Peso_Extintor: '1.5KG e 2.5KG',
                Alça: 'única'
            },
            features: [ 'Acessórios para extintores de incêndio', 'Suportes para veículos ']
        },
        {
            id: 12,
            name: 'Suporte de Veículo de Cinta Única Resistente CO2 Gama',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2021/08/Heavy-Duty-Single-Strap-CO2.jpg',
            description: 'Suportes de veículos para montagem e transporte seguros dos seguintes extintores: 2,5 kg, 4,5 kg e 9 kg.\n' +
                '\n' +
                'Como o nome sugere, os suportes de veículos são montados com segurança em veículos para ' +
                'transportar extintores de incêndio com segurança. Eles estão disponíveis em tamanhos e ' +
                'materiais variados, para permitir uma montagem e remoção rápida e fácil.',
            specifications: {
                Peso_Extintor: '2.5KG e 4.5KG',
                Alça: 'Única'
            },
            features: [ 'extintor de CO2', 'suportes para veículos']
        },
        {
            id: 13,
            name: 'Suporte de Veículo de Cinta Dupla Heavy Duty CO2 Gama',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2021/08/Heavy-Duty-Double-Strap-CO2.jpg',
            description: 'Suportes de veículos para montagem e transporte seguros dos seguintes extintores: 2,5 kg, 4,5 kg e 9 kg.\n' +
                '\n' +
                'Como o nome sugere, os suportes de veículos são montados com segurança em veículos ' +
                'para transportar extintores de incêndio com segurança. Eles estão disponíveis em ' +
                'tamanhos e materiais variados, para permitir uma montagem e remoção rápida e fácil.',
            specifications: {
                Peso_Extintor: '2.5KG, 4.5KG e 9KG',
                Alça: 'Dupla'
            },
            features: [ 'extintor de CO2', 'suportes para veículos']
        },
        {
            id: 14,
            name: 'Suporte de veículo leve com gaiola e correias',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2021/08/Light-Duty-Bracket-with-Cage.jpg',
            description: 'Suportes de veículos para montagem e transporte seguros dos seguintes extintores: 2,5 kg, 4,5 kg e 9 kg.\n' +
                '\n' +
                'Como o nome sugere, os suportes de veículos são montados' +
                ' com segurança em veículos para transportar extintores de ' +
                'incêndio com segurança. Eles estão disponíveis em tamanhos e ' +
                'materiais variados, para permitir uma montagem e remoção rápida e fácil.',
            specifications: {
                Peso_Extintor: '4.5KG e 9KG',
                Alça: 'Única'
            },
            features: [ 'extintores de incêndio', 'suportes para veículos']
        },
        {
            id: 15,
            name: 'Suporte de veículo leve sem gaiola e correias',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2021/08/Light-Duty-Bracket-No-Cage.jpg',
            description: 'Suportes de veículos para montagem e transporte seguros dos seguintes extintores: 2,5 kg, 4,5 kg e 9 kg.\n' +
                '\n' +
                'Como o nome sugere, os suportes de veículos são montados' +
                ' com segurança em veículos para transportar extintores de ' +
                'incêndio com segurança. Eles estão disponíveis em tamanhos e ' +
                'materiais variados, para permitir uma montagem e remoção rápida e fácil.',
            specifications: {
                Peso_Extintor: '2.5KG, 4.5KG e 9KG',
                Alça: 'Única',

            },
            features: [ 'extintores de incêndio', 'suportes para veículos']
        }
    ],
    5: [ // Armarios
        {
            id: 16,
            name: 'Armário Marítimo - Tipo um',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Untitled-1_0000_Marine-Cabinet-Type-3_12.jpg',
            description: 'O Gabinete Marítimo - tipo um é fabricado internamente por artesãos altamente ' +
                'qualificados, usando apenas resina e materiais de poliéster aprovados pela SABS',
            specifications: {
                Código_do_produto: 'FIRECABFG015/016',
                Altura: '520mm',
                Profundidade: '210mm',
                Largura: '670mm',


            },

            features: [ 'Melhore a segurança com mecanismo de travamento com chave, para garantir que apenas as pessoas apropriadas o utilizem.',
                'Evitar o roubo de equipamentos de incêndio',
                'Prolonga a vida útil do equipamento de incêndio, especialmente quando ao ar livre, um armário de incêndio protegerá o equipamento de incêndio contra todas as condições climáticas.',
                    'Proteção contra ferrugem em ambiente marinho.']
        },
        {
            id: 17,
            name: 'Armário de carretel de mangueira de porta dupla (fechado atrás)',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Double-Door-Hose-Reel-Cabinet-Closed-Back.jpg',
            description: 'Este armário de enrolador de mangueira de porta dupla tem uma parte traseira fechada com ' +
                '850 mm de altura e 850 mm de largura, fabricada internamente por artesãos altamente qualificados,' +
                ' usando apenas resina e materiais de poliéster aprovados pela SABS.',
            specifications: {
                Código_do_produto: 'FIRECABFG027',
                Altura: '850mm',
                Profundidade: '295mm',
                Largura: '850mm',
                Peso: '8,1kg'

            },

            features: [ 'Melhore a segurança com mecanismo de travamento com chave, para garantir que apenas as pessoas apropriadas o utilizem.',
                'Evitar o roubo de equipamentos de incêndio',
                'Prolonga a vida útil do equipamento de incêndio, especialmente quando ao ar livre, um armário de incêndio protegerá o equipamento de incêndio contra todas as condições climáticas.',
                'Proteção contra ferrugem em ambiente marinho.']
        },
        {
            id: 18,
            name: 'Gabinete Marítimo - Tipo dois',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Untitled-1_0000_Marine-Cabinet-Type-3_12.jpg',
            description: 'O Marine Cabinet - tipo dois é fabricado internamente por artesãos altamente ' +
                'qualificados, usando apenas resina e materiais de poliéster aprovados pela SABS. ' +
                'Um incêndio pode se espalhar por um prédio em pouco tempo – ferindo pessoas, ' +
                'destruindo ativos e ameaçando a própria existência do seu negócio. O que torna tudo ' +
                'ainda mais trágico é que etapas simples e comprovadas podem reduzir o risco de acidentes e ' +
                'ter armazenamento e proteção seguros visíveis para seu equipamento de incêndio.',
            specifications: {
                Código_do_produto: 'FIRECABFG017/018',
                Peso: '4.1KG',
                Altura: '520mm',
                Profundidade: '275mm',
                Largura: '670mm',


            },

            features: [ 'Melhore a segurança com mecanismo de travamento com chave, para garantir que apenas as pessoas apropriadas o utilizem.',
                'Evitar o roubo de equipamentos de incêndio',
                'Prolonga a vida útil do equipamento de incêndio, especialmente quando ao ar livre, um armário de incêndio protegerá o equipamento de incêndio contra todas as condições climáticas.',
                'Proteção contra ferrugem em ambiente marinho.']
        },
        {
            id: 19,
            name: 'Caixa de Fogo 4.5kg & 9kg',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Untitled-1_0007_4.5KG-Fire-Box_11.jpg',
            description: 'Este armário de porta articulada de 4,5 kg tem 570 mm de altura e 300 mm ' +
                'de largura, fabricado internamente por artesãos altamente qualificados, usando apenas ' +
                'resina e materiais de poliéster aprovados pela SABS.',
            specifications: {
                Código_do_produto: 'FIRECABFG013/FIBECABG014',
                Altura: '590mm/690mm',
                Profundidade: '280mm/280mm',
                Largura: '340mm/347mm',
                Peso: '3.2kg'

            },

            features: [ 'Melhore a segurança com mecanismo de travamento com chave, para garantir que apenas as pessoas apropriadas o utilizem.',
                'Evitar o roubo de equipamentos de incêndio',
                'Prolonga a vida útil do equipamento de incêndio, especialmente quando ao ar livre, um armário de incêndio protegerá o equipamento de incêndio contra todas as condições climáticas.',
                'Proteção contra ferrugem em ambiente marinho.']
        },

       {
            id: 20,
            name: 'Armário de porta deslizante 4,5 kg – Tipo um',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Sliding-Door-Cabinet-%E2%80%93-Type-one.jpg',
            description: 'Os armários com portas de correr – tipo um são fabricados internamente por artesãos altamente qualificados, usando apenas resina de poliéster e materiais aprovados pela SABS.',
            specifications: {
                Código_do_produto: 'FIRECABFG010',
                Altura: '1000mm',
                Profundidade: '340mm',
                Largura: '760mm',
                Peso: '9,4kg'

            },

            features: [ 'proteção', 'armários de armazenamento']
        },
        {
            id: 21,
            name: 'Armário de Porta de Correr 9kg – Tipo dois',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Sliding-Door-Cabinet-%E2%80%93-Type-two.jpg',
            description: 'Os armários com portas de correr – tipo dois são fabricados internamente por artesãos altamente qualificados, usando apenas resina de poliéster e materiais aprovados pela SABS.',
            specifications: {
                Código_do_produto: 'FIRECABFG011',
                Altura: '1000mm',
                Profundidade: '340mm',
                Largura: '760mm',
                Peso: '8,0kg'

            },

            features: [ 'proteção', 'armários de armazenamento']
        },
        {
            id: 22,
            name: 'Dobradiça Polly 9Kg',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Untitled-1_0006_9KG-Poly-Hinge_v1_11.jpg',
            description: 'A Dobradiça Polly de 9 kg é um componente robusto e confiável, projetado para aprimorar a funcionalidade e a segurança do seu extintor de incêndio. Esta dobradiça de alta qualidade foi projetada especificamente para gabinetes de extintores de incêndio de 9 kg, garantindo uma operação segura e suave. Sua construção durável garante um desempenho duradouro, tornando-a uma parte essencial do seu equipamento de segurança contra incêndio.',
            specifications: {
                Peso_Armario:'9kg',

            },

            features: [ 'proteção', 'armários de armazenamento']
        },
        {
            id: 23,
            name: 'Carretel de mangueira',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2023/11/Untitled-1_0004_C02_2157.jpg',
            description: 'Garanta segurança confiável contra incêndio com o Carretel de Mangueira. Projetado para combate eficiente e eficaz a incêndios, este carretel de mangueira de alta qualidade fornece um fluxo contínuo de água, permitindo uma resposta rápida e controlada a emergências de incêndio. Feito de materiais duráveis, ele é construído para suportar condições adversas e garantir um desempenho duradouro.',
            specifications: {
                Fluxo: 'Fluxo contínuo de água',
                Material: 'Materiais duráveis', 

            },

            features: [ 'proteção', 'armários de armazenamento']
        },
        {
            id: 24,
            name: 'Armário Extintor Duplo',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2023/11/Untitled-1_0003_Extinguisher-Cabinet-Double.jpg',
            description: 'Proteja seus extintores de incêndio com o Armário Duplo para Extintores. Este armário robusto foi projetado para acomodar dois extintores, proporcionando fácil acesso e segurança adicional. Feito com materiais duráveis, ele garante que seus extintores de incêndio estejam protegidos contra danos e roubos. ',
            specifications: {
                Quantidade:'2 extintores',
                Material: 'Materiais duráveis', 

            },

            features: [ 'proteção', 'armários de armazenamento']
        },
        {
            id: 25,
            name: 'Armário Extintor Simples',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2023/11/Untitled-1_0002_Extinguisher-Cabinet-Single.jpg',
            description: 'Proteja seus extintores de incêndio com o Armário simples para Extintores. Este armário robusto foi projetado para acomodar dois extintores, proporcionando fácil acesso e segurança adicional. Feito com materiais duráveis, ele garante que seus extintores de incêndio estejam protegidos contra danos e roubos. ',
            specifications: {
                Quantidade:'2 extintores',
                Material: 'Materiais duráveis', 

            },

            features: [ 'proteção', 'armários de armazenamento']
        },
        {
            id: 26,
            name: 'Caixa Geral',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2023/11/Untitled-1_0001_General-Box_2.jpg',
            description: 'A Caixa Geral é uma solução de armazenamento versátil e durável para seus equipamentos de segurança contra incêndio. Projetada para proteger e organizar diversas ferramentas e acessórios de segurança contra incêndio, esta caixa robusta garante fácil acesso e armazenamento seguro.',
            specifications: {
                Dimensões: 'Dimensões variadas',
                Material: 'Materiais duráveis', 
                Capacidade: 'Capacidade de armazenamento generosa'

            },

            features: [ 'proteção', 'armários de armazenamento']
        }
        

    ], 
    6: [ // Sinais Simbolicos
        {
            id: 30,
            name: 'Localização do extintor de incêndio',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Location-of-Fire-Extinguisher.jpg',
            description: ' Sinais de Incêndio ',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Sinais de Incêndio', ' segurança ocupacional']
        }, {
            id: 31,
            name: 'Localização do equipamento de combate a incêndio Seta vermelha para a direita',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Red-Arrow-Right.jpg',
            description: ' Sinais de Incêndio ',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Sinais de Incêndio', ' segurança ocupacional']
        }, {
            id: 32,
            name: 'Localização do equipamento de combate a incêndio Seta vermelha para a esquerda',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Red-Arrow-Left.jpg',
            description: ' Sinais de Incêndio ',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Sinais de Incêndio', ' segurança ocupacional']
        }, {
            id: 33,
            name: 'Localização do equipamento de combate a incêndio Seta vermelha para baixo',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Red-Arrow-Down.jpg',
            description: ' Sinais de Incêndio ',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Sinais de Incêndio', ' segurança ocupacional']
        }, {
            id: 34,
            name: 'Localização do equipamento de incêndio Red Arrow 45′ ',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Red-Arrow-45deg.jpg',
            description: ' Sinais de Incêndio ',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Sinais de Incêndio', ' segurança ocupacional']
        }, {
            id: 35,
            name: 'Localização da mangueira de incêndio',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Location-of-Fire-Hose.jpg',
            description: ' Sinais de Incêndio ',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Sinais de Incêndio', ' segurança ocupacional']
        }, {
            id: 36,
            name: 'Localização do hidrante',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Location-of-Fire-Hydrant.jpg',
            description: ' Sinais de Incêndio ',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Sinais de Incêndio', ' segurança ocupacional']
        }, {
            id: 37,
            name: 'Localização do cobertor de fogo',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Location-of-Fire-Blanket.jpg',
            description: ' Sinais de Incêndio ',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Sinais de Incêndio', ' segurança ocupacional']
        },

        //verde
        {
            id: 38,
            name: 'Arqueiro Verde 45′',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Sign-9.jpg',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 39,
            name: 'Escadas para baixo à direita',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Sign-10.jpg',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 40,
            name: 'Escadas para baixo à esquerda',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Sign-11.jpg',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 41,
            name: 'Escadas para cima à direita',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Sign-12.jpg',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 42,
            name: 'Escadas para cima à esquerda',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Sign-13.jpg',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 43,
            name: 'Banheiro feminino',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Sign-14.jpg',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 44,
            name: 'Banheiro masculino',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Mens-Toilet.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 45,
            name: 'Câmara de Refúgio',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Refuge-Chamber.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 46,
            name: 'Saída Verde',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Sign-17.jpg',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 47,
            name: 'Posto de primeiros socorros tripulado',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Manned-First-Aid-Station.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 48,
            name: 'Localização do saco de bomba',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Location-of-Bomb-Bag.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 49,
            name: 'Cadeiras de rodas',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Greehn-Wheelchair.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 50,
            name: 'Chuveiro de segurança',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Safety-Shower.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 51,
            name: 'Lava-olhos',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Eye-wash.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 52,
            name: 'Interruptor Isolador Elétrico',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Electric-Isolator-Switch.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        }, {
            id: 53,
            name: 'Parada de emergência',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Emergency-Stop.png',
            description: '  Placas de Informação',
            specifications: {
              Tamanhos_padrão: '190 x 190 mm e 290 x 290 mm ou qualquer outro tamanho que você precisar.'
            },
            features: [' Placas de Informação', ' segurança ocupacional']
        },





    ], 
    7: [ // Varriado
        {
            id: 1,
            name: 'Cobertor de fogo',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Fire-Blanket-.jpg',
            description: 'A manta anti-fogo é compacta, fácil de instalar, deve ser acessível, mas não muito próxima do risco, e suas instruções devem ser lidas e compreendidas antes do uso. Possui excelentes propriedades isolantes.',
            specifications: {
              Tamanho_01: '0,9 x 0,9',
              Tamanho_02: '1,2 x 1,2',
              Tamanho_03: '1,2 x 1,8',
              Tamanho_04: '1,8 x 1,8'
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },
        {
            id: 2,
            name: 'Batedores de fogo',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/08/Fire-Beater-300x300px.jpg',
            description: 'Os batedores de fogo têm cabo de madeira maciça ou alumínio e são feitos com borracha de nível industrial para combater incêndios florestais com eficácia. Podem ser usados ​​repetidamente.',
            specifications: {
              Comprimento_do_cabo: '1200 mm',
                Dimensões_do_batedor: '310 x 450 mm'
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 3,
            name: 'Machados de incêndio',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Fire-Axes-.jpg',
            description: 'Existem dois tipos principais de machados usados ​​no combate a incêndios. Um é o machado de cabeça chata, que possui apenas uma cunha para cortar objetos. O outro tipo é o machado de cabeça picareta, que possui uma cunha de corte em um dos lados e uma ponta pontiaguda para penetrar objetos.',
            specifications: {
              
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 4,
            name: 'Alarme de sinalização seguro e alto',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/08/Safe-Loud-300x300px.jpg',
            description: '',
            specifications: {
              
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 5,
            name: 'Detectores de fumaça',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Smoke-Alarms-.jpg',
            description: 'Detectores de fumaça fotoelétricos são projetados para detectar incêndios que duram horas antes de explodirem em chamas. Fontes desses incêndios podem incluir cigarros acesos em sofás ou roupas de cama.',
            specifications: {
                Alerta_precoce: 'os detectores de fumaça são projetados para fornecer sinais de alerta precoce em caso de incêndio, ajudando você e seus entes queridos a escapar com segurança e rapidez.',
                Monitoramento_24h: 'esses alarmes ficam ativos 24 horas por dia, 7 dias por semana, oferecendo proteção e tranquilidade 24 horas por dia, mesmo quando você estiver dormindo ou longe de sua propriedade.'
              
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 6,
            name: 'Kit de emergência para incêndio residencial',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Home-Emergency-Fire-Kit-.jpg',
            description: 'O kit de emergência para incêndio residencial é um kit compacto de proteção contra incêndio para uso doméstico e inclui um cobertor anti-incêndio de 0,9 m x 0,9 m, um detector de fumaça fotoelétrico operado por bateria e um extintor de incêndio descartável DCP de 0,6 kg.',
            specifications: {
              
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 7,
            name: 'Balde de fogo/areia',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/08/Fire-Bucket-300x300px-600x600.jpg',
            description: 'Um balde de areia para fogo ou balde de fogo é usado para extinguir incêndios, enchendo-o com areia e jogando-a sobre o fogo. Normalmente, os baldes de fogo são pintados de vermelho vivo, com a palavra "Fogo" escrita em estêncil branco.',
            specifications: {
              Extinção_Imediata_Incêndio: 'Uma solução de resposta rápida para pequenos incêndios, como incêndios de gordura em cozinhas, incêndios elétricos ou incêndios em lixeiras. A areia abafa eficazmente as chamas, impedindo que se espalhem.',
                Fácil_de_usar: 'A simplicidade do balde de areia o torna fácil de usar e adequado para todas as idades. Em caso de incêndio, basta pegar o balde, remover a tampa e despejar a areia sobre as chamas.'
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 8,
            name: 'Placas de apoio',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Backing-Board-1.jpg',
            description: 'Essas placas de suporte de madeira são usadas para fixar extintores de incêndio com suportes de montagem na parede.',
            specifications: {
                BACBOA001: 'Painel de apoio 450 mm (econômico)',
                BACBOA002: 'Painel de apoio 600 mm (econômico)',
                BACBOA003: 'Painel de apoio 800 mm (econômico)',
                BACBOA004: 'Painel de apoio de 9 kg (Saligna)',
                BACBOA005: 'Cartão de apoio de 4,5 kg (Saligna)',
                BACBOA007: 'Painel de apoio 450 mm (Pinho)',
                BACBOA008: 'Painel de apoio 600 mm (Pinho)',
                BACBOA009: 'Painel de apoio 800 mm (Pinho)',
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 9,
            name: 'Caixas de Chaves',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Key-Boxes-.jpg',
            description: 'São caixas de metal ou plástico para armazenamento seguro de chaves de portas de saída, com função de quebra de vidro em caso de emergência de incêndio.',
            specifications: {
              
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 10,
            name: 'Redlam Panic Bolt',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Redlam-Panic-Bolt-1-1.jpg',
            description: 'O ferrolho antipânico Redlam é fabricado em alumínio fundido e é a solução econômica para o problema de fornecer segurança confiável para saídas de emergência internas.',
            specifications: {
                Comprimento: '165 mm',
                Altura: '75 mm',
                Profundidade : '55 mm',
                Dimensões: '120 mm x diâmetro 20 mm (dimensões aproximadas)'
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 11,
            name: 'Kits de primeiros socorros',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/First-Aid-Kits-.jpg',
            description: 'O kit de primeiros socorros da Safequip é um conjunto de suprimentos e equipamentos para primeiros socorros, elaborado propositalmente. O conteúdo varia bastante de acordo com as necessidades da área onde pode ser utilizado e com as variações na legislação ou regulamentação de cada região.',
            specifications: {
              
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 12,
            name: 'Purificador de água da chuva “Tanque”',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Rainwater-Purification-600x600.png',
            description: 'A água da chuva começa limpa, livre de bactérias e vírus, mas assim que atinge uma superfície coletora, como um telhado, bactérias perigosas podem entrar na água. Excrementos de animais e pássaros, poeira, sujeira e matéria vegetal em decomposição, como folhas, podem contaminar a água do tanque.',
            specifications: {
              
            },
            features: [' Diversos ', ' equipamentos de combate a incêndio ' ]
        },





    ],
    8:[// Mangueiras e acolpamentos
        {
            id: 1,
            name: 'Mangueira de incêndio Value Range',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Economy-Firehose.jpg',
            description: 'As mangueiras de incêndio da linha Value são úteis para aplicações de bombeamento de água em diversos setores, incluindo agricultura, construção, mineração e tratamento de águas residuais. Geralmente utilizadas pelo Corpo de Bombeiros, impulsionadas por bomba a diesel ou caminhão de bombeiros. As mangueiras planas eram originalmente feitas de lona, ​​que era propensa a apodrecer; as mangueiras atuais são feitas de materiais sintéticos, de fácil manutenção, e estas mangueiras com revestimento duplo são específicas para maior durabilidade. Disponíveis em embalagens de 30 m com diâmetros de 38 mm, 45 mm, 50 mm ou 65 mm.',
            specifications: {
              Diâmetros: '30 m com diâmetros de 38 mm, 45 mm, 50 mm ou 65 mm.' 
            },
            features: [' Mangueiras e Acessórios ', ' equipamentos de combate a incêndio ' ]
        },
        {
            id: 2,
            name: 'Mangueira Duraflex Progresso',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Duraflex-Firehose.jpg',
            description: 'Os acoplamentos de mangueira de incêndio são dispositivos mecânicos usados ​​para conectar duas mangueiras de incêndio ou uma mangueira a uma fonte de água, como um hidrante ou bomba. Eles permitem que a água flua livremente entre as mangueiras ou da fonte para a mangueira.',
            specifications: {
             
            },
            features: [' Mangueiras e Acessórios ', ' equipamentos de combate a incêndio ' ]
        },
        {
            id: 3,
            name: 'Mangueira de incêndio Cobra',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Cobra-Fire-Hose-.jpg',
            description: 'A Mangueira de Incêndio Cobra é uma mangueira antipercolação com revestimento robusto e totalmente sintético. É ideal para situações em que é necessário evitar danos causados ​​pela água ou onde se utiliza equipamento de produção de espuma, com excelentes benefícios e recursos econômicos.',
            specifications: {
              Diâmetros: '30 m com diâmetros de 38 mm, 45 mm, 50 mm ou 65 mm.' 
            },
            features: [' Mangueiras e Acessórios ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 4,
            name: 'Mangueira de incêndio Forester',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Forester-Fire-Hose-.jpg',
            description: 'A Mangueira de Incêndio Forester é uma mangueira percoladora com revestimento robusto e totalmente sintético. É adequada para incêndios florestais e de campo, com o revestimento externo permanecendo úmido durante o uso. Essas mangueiras são à prova de apodrecimento e não precisam ser secas após o uso.',
            specifications: {
             Diâmetros: '30 m com diâmetros de 38 mm, 45 mm, 50 mm ou 65 mm.'
            },
            features: [' Mangueiras e Acessórios ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 5,
            name: 'Mangueira de incêndio Firecheck',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Firecheck-Fire-Hose-.jpg',
            description: 'A mangueira de incêndio Firecheck é uma mangueira não percolante com um revestimento robusto e totalmente sintético. Ela foi projetada para uso por bombeiros e indústrias, com grandes benefícios e recursos de economia. O revestimento permite que a mangueira seja facilmente limpa após o uso, aumentando a resistência à abrasão e a vida útil da mangueira. O revestimento de PVC/Nitrila proporciona maior proteção contra contaminação por óleo e produtos químicos.',
            specifications: {
              Diâmetros: '30 m com diâmetros de 38 mm, 45 mm, 50 mm ou 65 mm.'
            },
            features: [' Mangueiras e Acessórios ', ' equipamentos de combate a incêndio ' ]
        },{
            id: 6,
            name: 'Mangueira de incêndio PolyZ',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/07/Duraflex-Firehose.jpg',
            description: ' A Mangueira de Incêndio PolyZ é uma mangueira antipercolação com revestimento robusto e totalmente sintético, projetada como uma mangueira tipo caixa, sem necessidade de secagem após o uso e, se necessário, pode ser facilmente reparada. Com um material de nova geração, é muito leve para manuseio.',
            specifications: {
             Diâmetros: '30 m com diâmetros de 38 mm, 45 mm, 50 mm ou 65 mm.'
            },
            features: [' Mangueiras e Acessórios ', ' equipamentos de combate a incêndio ' ]
        },

    ],
    9:[//agentes extintores

        {
            id: 1,
            name: 'Pó Químico Seco (Classe ABC)',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Foam-Alpha-Megaflo_safequip.jpg',
            description: 'Pó Químico Seco (Classe ABC) é um pó à base de fosfato monoamônico, geralmente para uso polivalente em incêndios de Classe A, B e C. Esses pós químicos secos estão disponíveis em concentrações de 40% e 90%. APROVADO pela SANS1522.',
            specifications: {
                Incêndios_Classe_A:'Ele isola incêndios de Classe A derretendo a aproximadamente 350–400 graus F.Incêndios de Classe "A" são causados ​​pela queima de materiais combustíveis comuns, como madeira, papel ou lixo.',
                Incêndios_Classe_B:'O pó quebra a reação em cadeia de incêndios de Classe B revestindo a superfície à qual é aplicado.Incêndios de Classe B consistem em líquido ou gás inflamável que inclui gasolina, óleo, propano e gás natural.',
                Incêndios_Classe_C:'É seguro e eficaz para incêndios de Classe C, pois não é condutor de eletricidade.O incêndio de Classe C lida com equipamentos elétricos energizados e precisa ser apagado com equipamentos que não conduzam sua energia de volta para o usuário, como no caso da água. A eletricidade também pode causar incêndios de Classe A e B.'            },
            features: [' Agentes Extintores ', 'Suportes para veículos' ]
        },
        {
            id: 2,
            name: 'Espuma de combate a incêndio Firechem',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/FOAM4Safequip.jpg',
            description: 'A espuma é uma solução aerada utilizada na prevenção e combate a incêndios. O concentrado de espuma é o líquido concentrado que é diluído e processado para produzir espuma. A solução de espuma é a mistura produzida pela diluição do concentrado de espuma com água antes do processamento para produzir espuma.',
            specifications: {
                Espumas_Classe_A:'são usadas principalmente no combate a incêndios florestais. Elas auxiliam na umectação e saturação de combustíveis Classe A com água, o que auxilia na supressão de incêndios e pode prevenir a reativação.',
                Espumas_classe_B: 'são mais adequadas para extinguir incêndios que envolvam líquidos inflamáveis.', 
                Espumas_sintéticas: 'proporcionam melhor fluxo e extinção mais rápida das chamas, mas oferecem segurança limitada após o incêndio.',
                Espumas_proteína: 'são biodegradáveis. Fluem e se espalham mais lentamente do que a espuma sintética, mas proporcionam uma camada de espuma resistente ao calor e são mais duráveis.'
                
            },
            features: [' Agentes Extintores ', 'Suportes para veículos' ]
        },{
            id: 3,
            name: 'K roxo',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/refinaryFire6Safequip.jpg',
            description: 'Este agente extintor de incêndio é usado em instalações militares, empresas petrolíferas e veículos, etc. O Safequip Purple K é um produto químico seco chamado bicarbonato de potássio que não é condutor nem corrosivo e pode ser limpo por aspiração, varredura ou enxágue com água.',
            specifications: {
                
            },
            features: [' Agentes Extintores ', 'Suportes para veículos' ]
        },{
            id: 4,
            name: 'hProduto químico úmido',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/kitchenfire3.jpg',
            description: 'evido às suas altas temperaturas de autoignição, incêndios em óleo de cozinha são difíceis de extinguir. Para extingui-los, eles precisam ser resfriados o suficiente, portanto, extintores convencionais não são tão eficazes devido ao risco de retrocesso de chama e reignição.',
            specifications: {
                
            },
            features: [' Agentes Extintores ', 'Suportes para veículos' ]
        },{
            id: 1,
            name: 'Pó Químico Seco (Classe BC)',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/FlamableLiquidFireClassB.jpg',
            description: 'O pó químico seco é dividido em Classe ABC e Classe BC. Esta Classe BC de pó químico seco consiste no Safequip Purple K e no SODA  BIC.',
            specifications: {
                Beta_Super_FLo:'90%',
                Beta_Hyper_Flo:'40%'
            },
            features: [' Agentes Extintores ', 'Suportes para veículos' ]
        },





    ],
    11:[//Hidradantes de incendio e tubos de sporte
         {
            id: 1,
            name: 'Válvula de hidrante',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Fire-Hydrant-Valve-.jpg',
            description: 'Uma válvula de hidrante  é uma conexão de tubulação  que ajuda a regular, direcionar ou controlar o fluxo de agentes de extinção de incêndio, abrindo, fechando ou obstruindo parcialmente as passagens nos conectores da mangueira. Válvulas de retenção impedem que o agente de extinção de incêndio flua na direção errada.',
            specifications: {
             Ângulo_reto: '80 mm Latão',
             Ângulo_reto_80_mm: ' Ferro fundido e adaptador'

            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },
          {
            id: 2,
            name: 'Tubos de descarga',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Standpipes.jpg',
            description: 'Um hidrante é um tipo de tubulação rígida de água instalada verticalmente em edifícios de vários andares, à qual mangueiras de incêndio podem ser conectadas, permitindo a aplicação manual de água no local do incêndio. No contexto de um edifício ou ponte, um hidrante serve à mesma finalidade de um hidrante. ',
            specifications: {
                1: 'Tubo vertical de cabeça sólida com alça e sem fechamento.',
                2: 'Tubo vertical de cabeça giratória sem fechamento.',
                3: 'Tubo vertical de cabeça giratória com válvula de rosca.',
                4: 'Tubo vertical de cabeça giratória com conexão padrão britânico BS336.'
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },
        {
            id: 3,
            name: 'Conector de reforço',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/04/Booster-Connector-.jpg',
            description: 'O Conector de Reforço é um produto de alta qualidade, fabricado inteiramente com materiais intrinsecamente resistentes à corrosão, e utiliza a tecnologia "O-Ring" para garantir uma operação durável, à prova de vazamentos e sem problemas. Seu design de válvula interna proporciona um fluxo de água eficiente em todas as pressões normais de operação e sua rosca cônica supera os problemas de junção sempre associados à instalação do Conector de Reforço para Corpo de Bombeiros. ',
            specifications: {
                Materiais: 'Latão e aço inoxidável',
                Rosca: 'Rosca de tubo de furo nominal de 80 mm (cônica 3″ BSP conforme BS 21.173)',
                Acoplamento_da_casa: 'Macho, instantâneo.',
                Peso: '2 kg',
                Fluxo_a_200kPa:'  1200 l/min.',
                Pressão_de_teste: '2000 kPa'
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 4,
            name: 'Cabeça sólida com alça sem fechamento',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/HR-Solid-Head-with-handle-without-Shut-off-2.jpg',
            description: ' Cabeça sólida com alça sem fechamento',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 5,
            name: 'Cabeça giratória sem desligamento',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/HR-Solid-Head-without-Shut-off.jpg',
            description: 'Cabeça giratória sem desligamento ',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 6,
            name: 'Cabeça giratória',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/HR-Swivel-Head.jpg',
            description: 'Cabeça giratória ',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 7,
            name: 'Cabeça giratória com válvula de rosca',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/HR-Swivel-Head-with-scrrew-down-valve.jpg',
            description: 'Cabeça giratória com válvula de rosca ',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 8,
            name: 'Conexão de cabeça giratória padrão britânico BS 336',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/HR-Swivel-Head-British-Standard-BS-Connection.jpg',
            description: 'Conexão de cabeça giratória padrão britânico BS 336 ',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 9,
            name: 'Tubos de suporte',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/HR-Safequip-Standpipes-various-1.jpg',
            description: ' Tubos de suporte',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 10,
            name: 'Ângulo reto 80 mm latão',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Right-Angle-80mm-Brass-.jpg',
            description: ' Uma válvula de hidrante  é uma conexão de tubulação  que ajuda a regular, direcionar ou controlar o fluxo de agentes de extinção de incêndio, abrindo, fechando ou obstruindo parcialmente as passagens nos conectores da mangueira. Válvulas de retenção impedem que o agente de extinção de incêndio flua na direção errada.',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 11,
            name: 'Válvula de hidrante marítima 50 mm latão',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Marine-Hydrant-Valve-50mm-Brass-.jpg',
            description: ' Uma válvula de hidrante  é uma conexão de tubulação  que ajuda a regular, direcionar ou controlar o fluxo de agentes de extinção de incêndio, abrindo, fechando ou obstruindo parcialmente as passagens nos conectores da mangueira. Válvulas de retenção impedem que o agente de extinção de incêndio flua na direção errada.',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 12,
            name: 'Hidrante de latão à prova de violação',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/Untitled-1_0005_Tamper-Proof-Brass-Hydrant.jpg',
            description: 'Uma válvula de hidrante  é uma conexão de tubulação  que ajuda a regular, direcionar ou controlar o fluxo de agentes de extinção de incêndio, abrindo, fechando ou obstruindo parcialmente as passagens nos conectores da mangueira. Válvulas de retenção impedem que o agente de extinção de incêndio flua na direção errada. ',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 13,
            name: 'Válvula de hidrante de latão 80 mm oblíqua de latão',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2020/05/HYDVAL005.jpg',
            description: 'Uma válvula de hidrante  é uma conexão de tubulação  que ajuda a regular, direcionar ou controlar o fluxo de agentes de extinção de incêndio, abrindo, fechando ou obstruindo parcialmente as passagens nos conectores da mangueira. Válvulas de retenção impedem que o agente de extinção de incêndio flua na direção errada. ',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 14,
            name: 'Válvula de hidrante oblíqua',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2023/11/Untitled-1_0003_Oblique-Hydrant-valve.jpg',
            description: ' Uma válvula de hidrante  é uma conexão de tubulação  que ajuda a regular, direcionar ou controlar o fluxo de agentes de extinção de incêndio, abrindo, fechando ou obstruindo parcialmente as passagens nos conectores da mangueira. Válvulas de retenção impedem que o agente de extinção de incêndio flua na direção errada.',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },{
            id: 15,
            name: 'Válvula de hidrante de latão Carretel de mangueira',
            price: '',
            image: 'https://safequip.co.za/wp-content/uploads/2023/11/Untitled-1_0004_Brass-Hydrant-Valve-HR1.jpg',
            description: 'Uma válvula de hidrante  é uma conexão de tubulação  que ajuda a regular, direcionar ou controlar o fluxo de agentes de extinção de incêndio, abrindo, fechando ou obstruindo parcialmente as passagens nos conectores da mangueira. Válvulas de retenção impedem que o agente de extinção de incêndio flua na direção errada. ',
            specifications: {
           
            },
            features: [' Válvulas de hidrante de incêndio ', '  válvulas ' ]
        },


    ]
};